export type Outcome = "deflected" | "cancelled" | "abandoned";

export const outcomes: Outcome[] = ["deflected", "cancelled", "abandoned"];

export const selectOutcomes = outcomes.map((outcome) => ({
  value: outcome,
  label: outcome.charAt(0).toUpperCase() + outcome.slice(1),
}));

export const colorsByOutcome: Record<Outcome, string> = {
  deflected: "green",
  cancelled: "red",
  abandoned: "gray",
};
